// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useQuery, useQueryClient } from "@tanstack/react-query";
// import { LayoutGrid, Users, SquareCheckBig, Calendar1, CalendarCheck2, LogOut, BarChart2, Building2, CreditCard, ShieldOff, UserCircle,Ticket } from "lucide-react";
// import logo from "../assets/img/logo1.png";
// import { getProfile, logoutUser } from "../api";

// const allNavItems = [
//   { key: "dashboard-overview", label: "Dashboard Overview", icon: <BarChart2 size={18} />, roles: ["super admin"] },
//   { key: "organizations", label: "Organizations", icon: <Building2 size={18} />, roles: ["super admin"] },
//   // { key: "subscriptions", label: "Subscriptions", icon: <CreditCard size={18} />, roles: ["super admin"] },
//   // { key: "access-control", label: "Access Control", icon: <ShieldOff size={18} />, roles: ["super admin"] },
//   { key: "employee", label: "Employee Management", icon: <Users size={18} />, roles: ["admin","training coordinator"] },
//   // { key: "role", label: "Roles & Permissions", icon: <SquareCheckBig size={18} />, roles: ["super admin"] },
//   { key: "session", label: "Session Management", icon: <Calendar1 size={18} />, roles: ["admin","training coordinator"] },
//   { key: "attendance", label: "Attendance Report", icon: <CalendarCheck2 size={18} />, roles: ["admin","training coordinator"] },
//   { key: "profile", label: "Profile", icon: <UserCircle size={18} />, roles: ["super admin", "admin", "training coordinator"] },
//  { key: "getsupport", label: "Get Support", icon: <Ticket size={18} />, roles: [ "admin",] },
//  { key : 'supportticket', label: 'Support Ticket', icon: <Ticket size={18} />, roles: [ "super admin","developer"] },
// ];

// export default function Sidebar({ active, setActive }) {
//   const navigate = useNavigate();
//   const queryClient = useQueryClient();
//   const { data, isLoading } = useQuery({ queryKey: ["profile"], queryFn: getProfile, staleTime: 5 * 60 * 1000 });
//   const user = data?.user ?? JSON.parse(localStorage.getItem("user") || "{}");
//   const role = user?.role || "";
//   const isSuperAdmin = role.toLowerCase() === "super admin";
//   const isAdmin = role.toLowerCase() === "admin";

//   const navItems = allNavItems.filter((item) => item.roles.includes(role.toLowerCase()));

//   if (isLoading) return <div style={{ width: 280, height: "100vh", background: "#080e21" }} />;
//   return (
//     <div style={styles.sidebar}>

//       <div style={styles.menu}>
//         <div style={{ marginBottom: 52, display: "flex", justifyContent: "center" }}>
//           <img src={logo} alt="logo" style={styles.logoImg} />
//         </div>
//         {navItems.map((item) => (
//           <div
//             key={item.key}
//             onClick={() => setActive(item.key)}
//             style={{ ...styles.navItem, ...(active === item.key ? styles.activeItem : {}) }}
//           >
//             <span style={styles.icon}>{item.icon}</span>
//             <span>{item.label}</span>
//           </div>
//         ))}
//       </div>

//       <div style={styles.profile}>
//         <img src={user.profilePhoto || "https://i.pravatar.cc/100"} alt="avatar" style={styles.avatar} onClick={() => navigate("/profile")} />
//         <div style={{ flex: 1 }}>
//           <div style={styles.name}>{user.firstName} {user.lastName}</div>
//           <div style={styles.email}>{user.email}</div>
//         </div>
//         <LogOut size={22} color="#94a3b8" style={{ cursor: "pointer" }} onClick={async () => {
//             try { await logoutUser(); } catch (_) {}
//             localStorage.removeItem("user");
//             queryClient.clear();
//             navigate("/login");
//           }} />
//       </div>

//     </div>
//   );
// }

// const styles = {
//   sidebar: {
//     width: 280,
//     height: "100vh",
//     background: "#080e21",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-between",
//     padding: "10px",
//     borderRight: "1px solid #14212d",
//     boxShadow: "4px 0 12px rgba(0,0,0,0.3)",
//   },
//   logoImg: {
//     width: "80%",
//     objectFit: "contain",
//   },
//   menu: {
//     display: "flex",
//     flexDirection: "column",
//     marginTop: 0,
//   },
//   navItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: 12,
//     padding: "10px 14px",
//     borderRadius: 8,
//     cursor: "pointer",
//     color: "#94a3b8",
//     fontSize: 13,
//     fontWeight: 400,
//     transition: "all 0.2s",
//   },
//   activeItem: {
//     background: "#14212d",
//     color: "#ffffff",
//     fontWeight: 600,
//   },
//   icon: {
//     display: "flex",
//     alignItems: "center",
//   },
//   profile: {
//     display: "flex",
//     alignItems: "center",
//     gap: 10,
//     padding: "10px 12px",
//     border: "1px solid #14212d",
//     borderRadius: 10,
//     marginBottom: 16,
//     background: "#14212d",
//   },
//   avatar: {
//     width: 40,
//     height: 40,
//     borderRadius: "50%",
//     objectFit: "cover",
//   },
//   name: {
//     fontSize: 14,
//     fontWeight: 600,
//     color: "#ffffff",
//   },
//   email: {
//     fontSize: 12,
//     color: "#94a3b8",
//   },
// };



import React from "react";

import { useNavigate } from "react-router-dom";

import {
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import {
  Users,
  Calendar1,
  CalendarCheck2,
  LogOut,
  BarChart2,
  Building2,
  UserCircle,
  Ticket,
} from "lucide-react";

import logo from "../assets/img/logo1.png";

import {
  getProfile,
  logoutUser,
} from "../api";


const allNavItems = [

  {
    key: "dashboard-overview",
    label: "Dashboard Overview",
    icon: <BarChart2 size={18} />,
    roles: ["super admin"],
  },

  {
    key: "organizations",
    label: "Organizations",
    icon: <Building2 size={18} />,
    roles: ["super admin"],
  },

  {
    key: "employee",
    label: "Employee Management",
    icon: <Users size={18} />,
    roles: [
      "admin",
      "training coordinator",
    ],
  },

  {
    key: "session",
    label: "Session Management",
    icon: <Calendar1 size={18} />,
    roles: [
      "admin",
      "training coordinator",
    ],
  },

  {
    key: "attendance",
    label: "Attendance Report",
    icon: <CalendarCheck2 size={18} />,
    roles: [
      "admin",
      "training coordinator",
    ],
  },

  {
    key: "profile",
    label: "Profile",
    icon: <UserCircle size={18} />,
    roles: [
      "super admin",
      "admin",
      "training coordinator",
    ],
  },

  {
    key: "getsupport",
    label: "Get Support",
    icon: <Ticket size={18} />,
    roles: ["admin"],
  },

  {
    key: "supportticket",
    label: "Support Ticket",
    icon: <Ticket size={18} />,
    roles: [
      "super admin",
      "developer",
    ],
  },

];


export default function Sidebar({
  active,
  setActive,
}) {

  const navigate = useNavigate();

  const queryClient =
    useQueryClient();


  const {
    data,
    isLoading,
  } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
    staleTime: 5 * 60 * 1000,
  });


  const user =
    data?.user ??
    JSON.parse(
      localStorage.getItem("user") || "{}"
    );


  const role =
    user?.role || "";


  const navItems =
    allNavItems.filter(
      (item) =>
        item.roles.includes(
          role.toLowerCase()
        )
    );


  if (isLoading) {

    return (
      <div
        style={{
          width: 280,
          height: "100vh",
          background: "#080e21",
        }}
      />
    );

  }


  const handleLogout =
    async () => {

      try {
        await logoutUser();
      } catch (_) {}

      localStorage.removeItem(
        "user"
      );

      queryClient.clear();

      navigate("/login");
    };


  return (

    <div style={styles.sidebar}>


      {/* LOGO */}

      <div style={styles.menu}>

        <div style={styles.logoContainer}>

          <img
            src={logo}
            alt="logo"
            style={styles.logoImg}
          />

        </div>


        {/* NAVIGATION */}

        <div style={styles.navContainer}>

          {navItems.map((item) => (

            <div
              key={item.key}
              onClick={() =>
                setActive(item.key)
              }
              style={{
                ...styles.navItem,

                ...(active === item.key
                  ? styles.activeItem
                  : {}),
              }}
            >

              <span style={styles.icon}>
                {item.icon}
              </span>

              <span style={styles.label}>
                {item.label}
              </span>

            </div>

          ))}

        </div>

      </div>


      {/* USER PROFILE */}

      <div style={styles.profile}>

        <img
          src={
            user.profilePhoto ||
            "https://i.pravatar.cc/100"
          }
          alt="avatar"
          style={styles.avatar}
          onClick={() =>
            navigate("/profile")
          }
        />


        <div style={styles.userInfo}>

          <div style={styles.name}>
            {user.firstName}{" "}
            {user.lastName}
          </div>

          <div style={styles.email}>
            {user.email}
          </div>

        </div>


        <LogOut
          size={22}
          color="#94a3b8"
          style={{
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={handleLogout}
        />

      </div>

    </div>

  );
}


const styles = {

  sidebar: {
    width: 280,
    height: "100vh",
    boxSizing: "border-box",
    background: "#080e21",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "10px",
    borderRight:
      "1px solid #14212d",
    boxShadow:
      "4px 0 12px rgba(0,0,0,0.3)",
    overflowY: "auto",
    overflowX: "hidden",
  },


  menu: {
    display: "flex",
    flexDirection: "column",
  },


  logoContainer: {
    marginBottom: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },


  logoImg: {
    width: "80%",
    maxWidth: 220,
    height: "auto",
    objectFit: "contain",
  },


  navContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },


  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "11px 14px",
    minHeight: 42,
    boxSizing: "border-box",
    borderRadius: 8,
    cursor: "pointer",
    color: "#94a3b8",
    fontSize: 13,
    fontWeight: 400,
    transition:
      "all 0.2s ease",
    userSelect: "none",
  },


  activeItem: {
    background: "#14212d",
    color: "#ffffff",
    fontWeight: 600,
  },


  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },


  label: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },


  profile: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    border:
      "1px solid #14212d",
    borderRadius: 10,
    marginBottom: 6,
    background: "#14212d",
    minWidth: 0,
  },


  avatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
    cursor: "pointer",
    flexShrink: 0,
  },


  userInfo: {
    flex: 1,
    minWidth: 0,
  },


  name: {
    fontSize: 14,
    fontWeight: 600,
    color: "#ffffff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },


  email: {
    fontSize: 12,
    color: "#94a3b8",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

};

